import { __rest, __assign } from '../../../node_modules/tslib/tslib.es6.js';
import { jsxs, jsx } from 'react/jsx-runtime';
import { UncontrolledTooltip } from 'reactstrap';
import { useState, useMemo } from 'react';
import classNames from 'classnames';
import { Cell } from './Cell.js';
import SvgEdit24 from '../../../icons/interface/Edit24.js';
import SvgTrash24 from '../../../icons/interface/Trash24.js';
import { generateRandomString } from '../../../helpers/stringFunctions.js';

var ActionCell = function (_a) {
    var actionType = _a.actionType, className = _a.className, onClick = _a.onClick, label = _a.label, props = __rest(_a, ["actionType", "className", "onClick", "label"]);
    var uniqueRowId = useState(generateRandomString())[0];
    var actualLabel = useMemo(function () {
        return label ? label : actionType === 'edit' ? 'Edit' : 'Remove';
    }, [actionType, label]);
    var Icon = actionType === 'edit' ? SvgEdit24 : SvgTrash24;
    return (jsxs(Cell, __assign({}, props, { className: classNames('position-relative', className) }, { children: [jsx("button", __assign({ id: "table-action-row-".concat(uniqueRowId), className: "btn btn-darker-quartenary text-default rounded-0 p-0 absolute-fill", onClick: onClick, "data-testid": "table-row-action" }, { children: jsx(Icon, { className: "position-absolute start-50 translate-middle-x opacity-100 table-cell-square-icon" }) })), jsx(UncontrolledTooltip, __assign({ popperClassName: "tooltip-light tooltip-lg mb-n2 pe-none", target: "table-action-row-".concat(uniqueRowId) }, { children: actualLabel }))] })));
};

export { ActionCell };
